import { Component, EventEmitter, Inject, Input, OnInit } from '@angular/core';
import { hebrewDays } from '../../../shared/constants/hebrew-days';
import { DOCUMENT } from '@angular/common';
import { PortalWidgetType } from 'src/app/models/enums/PortalWidgetType';
import { LocalizationService } from '../../services/localization.service';

@Component({
  selector: 'app-widget-student-calendar',
  templateUrl: './widget-student-task-calendar.html',
  styleUrls: ['./widget-student-task-calendar.scss']
})
export class WidgetStudentTaskCalendar implements OnInit {
  @Input() widgetData!: any;
  calendarWidgetExist: boolean = false;
  currentDate: Date = new Date();
  selectedDay: Date = new Date();
  currentDay: string = hebrewDays[this.currentDate.getDay()];
  selectedTabIndex: number = 1;
  openedFull: EventEmitter<boolean> = new EventEmitter<boolean>();

  LocalizationService = LocalizationService;

  constructor(@Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    this.initWidget();
  }

  initWidget() { 
    this.calendarWidgetExist = true;
  }

  toggleFullContent(state: boolean, event: any | null = null) {
    if(event) event.preventDefault();
    this.openedFull.emit(state);
    this.toggleBodyClass(state);
  }

  toggleBodyClass(state: boolean) {
    if (state) {
      this.document.body.classList.add('opened-modal');
    } else {
      this.document.body.classList.remove('opened-modal');
    }
  }

  openDayDetails(day: Date){
    this.selectedDay = day;
    this.selectedTabIndex = 0;
  }

  tabChanged(index: number) {
    this.selectedTabIndex = index;
  }
}
